module.exports = __webpack_public_path__ + "static/media/starshipit5_preview.f59bf1d3.jpg";